import { render } from "./Crumb.vue?vue&type=template&id=4bf7b4b3"
import script from "./Crumb.vue?vue&type=script&lang=js"
export * from "./Crumb.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__